import reducer from "./reducers";

import * as ventasContactosOps from "./operations";
import * as ventasContactosTypes from "./types";

export { ventasContactosOps, ventasContactosTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/ventasContactos/index.js